<template>
  <div class="text-center">
      <a
        class="legacy-dashboard"
        :href="`${root}/admin/promoterDashboard`"
        target="_blank"
        rel="noopener noreferrer"
      >{{ $t("top-menu.all.legacy-dashboard") }}</a>
    <div class="styleMenuv" v-for="(option, index) in options" v-bind:key="index">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small link class="ma-2" dark v-bind="attrs" v-on="on" @click="redirect(option.href, option.items.length == 0)">
            <i v-if="option.icon" v-bind:class="option.icon"></i>
            &nbsp;{{ $t(option.lang) }}
          </v-btn>
        </template>
        <v-list v-if="option.items.length > 0">
          <v-list-item
            v-for="(item, index) in option.items"
            v-bind:key="index"
            @click="redirect(item.href,true)"
          >
            <v-list-item-title>{{ $t(item.lang) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["root"]),
    options: function () {
      const options = [
        {
          icon: "far fa-tachometer",
          lang: "top-menu.all.dashboard",
          name: 'PromoterDashboard',
          href: "/admin/promoterDashboard",
          legacy: true,
          items: []
        },
        {
          icon: "far fa-sitemap ",
          lang: "top-menu.report.series",
          href: `/promoter/#/series`,
          name: 'Serie',
          items: []
        },
        {
          icon: "far fa-users",
          lang: "top-menu.all.workers",
          href: `/promoter/#/workers`,
          name: 'Workers',
          items: []
        },
        {
          icon: "far fa-file ",
          lang: "top-menu.all.waiver",
          name: null,
          items: [
              { lang: "top-menu.all.sign_waiver", name: 'WaiverSign', href: `/promoter/#/waivers/sign` },
              { lang: "top-menu.all.create_waiver", name: 'CloneWaiversOld', href: `/promoter/#/waivers/cloneWaivers`},
              { lang: "top-menu.all.signed_waiver", name: 'Signed', href: `/promoter/#/waivers/signed` },
          ]
        },
        {
          icon: "far fa-file-chart-line ",
          lang: "top-menu.report.reports",
          href: `/promoter/#/reports`,
          name: 'Report',
          items: [],
        },
        {
          icon: "far fa-link",
          lang: "top-menu.all.promoterEventLink",
          href: `/promoter/#/promoterEventLink`,
          name: 'PromoterEventLink',
          items: [],
        },
        {
          icon: "fa fa-credit-card",
          lang: "top-menu.all.payment_manager",
          href: `/promoter/#/paymentManager`,
          name: 'PaymentManager',
          items: [],
        },
        {
          icon: "fa fa-first-aid",
          lang: "top-menu.all.medical_information",
          href: `/promoter/#/medicalInformation`,
          name: 'MedicalInformation',
          items: [],
        }
      ];
      this.generateTopMenu(options);
      return options;
    }
  },
  methods: {
    generateTopMenu: function (items) {
      let options = [];
      options = items.map((elem) => {
        const subitems = elem.items.map((elem1) => {
          return {
            ...elem1,
            text: this.$t(elem1.lang)
          };
        });
        return {
          ...elem,
          text: this.$t(elem.lang),
          items: subitems
        };
      });
      this.$emit("loadTopMenuResponsive", options);
    },
    redirect(url, band) {
      if(band)
        window.location.href = url;
    }
  }
};
</script>

<style scoped>
.legacy-dashboard {
  text-align: right !important;
  text-align: -moz-right !important;
  text-decoration: underline !important;
  color: #0e152d !important;
  margin-right: 10px;
}
.styleMenuv {
  display: inline;
}
</style>
